// axiosInstance, not the cachios client — a stale copy would keep showing
// an application the student just finished
import {axiosInstance as http} from "@/http_client";

/**
 * The student's certificate records (app/users/certificates): completed
 * certificates plus applications started and not finished. One source for
 * the Certificates & Forms page AND the section menu, so "In Progress
 * Applications" shows exactly when that page would list something.
 */
let pending = null;

export default {
    state: {
        certificates: null,   // null until loaded
        certifications: [],
    },
    getters: {
        certificates: state => state.certificates,
        certificateCertifications: state => state.certifications,
        certificatesLoaded: state => state.certificates !== null,
        inProgressApplicationCount: state => (state.certificates || []).filter(c => c.status === 'in_progress').length,
    },
    mutations: {
        setCertificates(state, {certificates, certifications}) {
            state.certificates = certificates || [];
            state.certifications = certifications || [];
        }
    },
    actions: {
        // The top bar and side menu both ask on mount; share one request
        getCertificates({commit}) {
            if (!pending) {
                pending = http.get('app/users/certificates').then(response => {
                    commit('setCertificates', response.data || {});
                    return response.data;
                }).finally(() => { pending = null; });
            }
            return pending;
        }
    }
};
